import BeachTrash from "assets/match/beach_trash.jpeg";
import BlackSand from  "assets/match/black_sand.jpg";
import Norway from  "assets/match/norway.jpg";
import PlaneVacation from  "assets/match/plane_vacation.jpg";
import SwissVacation from  "assets/match/swiss_vacation.jpg";
import TrainVacation from  "assets/match/train_vacation.jpg";

export const PAGE_TITLE = "HOTELFAN";

export const SUGGESTION_MATCH = [BeachTrash, BlackSand, Norway, PlaneVacation, SwissVacation, TrainVacation];